import MatchService from '../services/match.service';

const state = {
    matches: [],
    currentMatch: null,
    loading: false,
    error: null
};

const getters = {
    allMatches: state => state.matches,
    currentMatch: state => state.currentMatch,
    isLoading: state => state.loading,
    error: state => state.error
};

const actions = {
    fetchAllMatches({ commit }) {
        commit('setLoading', true);
        return MatchService.getAllMatches()
            .then(response => {
                commit('setMatches', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la récupération des matchs');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    fetchMatchById({ commit }, id) {
        commit('setLoading', true);
        return MatchService.getMatchById(id)
            .then(response => {
                commit('setCurrentMatch', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la récupération du match');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    createMatch({ commit }, matchData) {
        commit('setLoading', true);
        return MatchService.createMatch(matchData)
            .then(response => {
                commit('addMatch', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la création du match');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    updateMatch({ commit }, { id, matchData }) {
        commit('setLoading', true);
        return MatchService.updateMatch(id, matchData)
            .then(response => {
                commit('updateMatchInList', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la mise à jour du match');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    deleteMatch({ commit }, id) {
        commit('setLoading', true);
        return MatchService.deleteMatch(id)
            .then(() => {
                commit('removeMatch', id);
                commit('setLoading', false);
                return Promise.resolve();
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la suppression du match');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    fetchMatchesByUser({ commit }, userId) {
        commit('setLoading', true);
        return MatchService.getMatchesByUser(userId)
            .then(response => {
                commit('setMatches', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la récupération des matchs de l\'utilisateur');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    validateMatch({ commit }, id) {
        commit('setLoading', true);
        return MatchService.validateMatch(id)
            .then(response => {
                commit('updateMatchInList', response.data);
                commit('setLoading', false);
                return Promise.resolve(response.data);
            })
            .catch(error => {
                commit('setError', error.response?.data || 'Erreur lors de la validation du match');
                commit('setLoading', false);
                return Promise.reject(error);
            });
    },

    clearError({ commit }) {
        commit('setError', null);
    }
};

const mutations = {
    setMatches(state, matches) {
        state.matches = matches;
    },
    setCurrentMatch(state, match) {
        state.currentMatch = match;
    },
    addMatch(state, match) {
        state.matches.push(match);
    },
    updateMatchInList(state, updatedMatch) {
        const index = state.matches.findIndex(match => match.id === updatedMatch.id);
        if (index !== -1) {
            state.matches.splice(index, 1, updatedMatch);
        }
        if (state.currentMatch && state.currentMatch.id === updatedMatch.id) {
            state.currentMatch = updatedMatch;
        }
    },
    removeMatch(state, id) {
        state.matches = state.matches.filter(match => match.id !== id);
        if (state.currentMatch && state.currentMatch.id === id) {
            state.currentMatch = null;
        }
    },
    setLoading(state, status) {
        state.loading = status;
    },
    setError(state, error) {
        state.error = error;
    }
};

export const match = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}; 